export function partialUpperCase(text: string, startIndex = 0) {
  const start = text.slice(0, startIndex)
  const end = text.slice(startIndex).toLocaleUpperCase()
  return start + end
}
